import 'vue2-dropzone/dist/vue2Dropzone.css'
import './assets/sass/element-variables.scss'
import Vue from 'vue'
import App from './app/Main.vue'
import router from './router'
import store from './vuex'
import http from './http'
import ElementUI from 'element-ui'
import ptBr from 'element-ui/lib/locale/lang/pt-br'
import locale from 'element-ui/lib/locale'
import VueSweetAlert from 'vue-sweetalert'
import Vuelidate from 'vuelidate'
import VueTheMask from 'vue-the-mask'
import moment from 'moment'
import VueMomentJS from 'vue-momentjs'
import VueScrollTo from 'vue-scrollto'
import VueCookie from 'vue-cookie'

import './app/filters'

Vue.use(http, {router})
Vue.use(ElementUI)
locale.use(ptBr)
Vue.use(VueSweetAlert)
Vue.use(Vuelidate)
Vue.use(VueTheMask)
Vue.use(VueMomentJS, moment)
Vue.use(VueScrollTo)
Vue.use(VueCookie)

/**
 * Cria a instância do vue
 */
/* eslint-disable no-new */
new Vue({
  router,
  store,
  el: '#app',
  render: h => h(App)
})
